import { useRouter } from 'expo-router'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import Page from '@/components/shared/Page'
import UniButton from '@/components/unistyles/UniButton'
import UniText from '@/components/unistyles/UniText'
import trpc from '@/utils/trpc'

const Welcome = () => {
  const router = useRouter()
  const currentUser = trpc.user.current.useQuery({}).data

  return (
    <Page requiresSubscription={false} viewId="welcome">
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.headerContainer}>
            <UniText variant="headlineMedium">
              Welcome
              {currentUser?.firstName ? `, ${currentUser.firstName}` : ''}!
            </UniText>
            <UniText style={styles.subtitle} variant="titleMedium">
              Let's get you connected with your rescue organization
            </UniText>
          </View>

          <View style={styles.buttonContainer}>
            <UniText style={styles.label} variant="titleMedium">
              Choose your role:
            </UniText>

            <UniButton
              contentStyle={styles.buttonContent}
              mode="contained"
              onPress={() => router.push('/getting-started/waiting')}
            >
              I volunteer for a rescue
            </UniButton>

            <UniButton
              contentStyle={styles.buttonContent}
              mode="outlined"
              onPress={() => router.push('/getting-started/setup')}
            >
              I operate an animal rescue
            </UniButton>
          </View>

          <View style={styles.infoContainer}>
            <UniText style={styles.infoText} variant="bodyMedium">
              Rescue operators will be guided through creating their
              organization. Volunteers will need an invitation from their rescue
              organization.
            </UniText>
          </View>
        </View>
      </View>
    </Page>
  )
}

const styles = StyleSheet.create((theme) => ({
  buttonContainer: {
    alignItems: 'stretch',
    gap: theme.tokens.spacing[3],
    width: '100%',
  },
  buttonContent: {
    paddingVertical: theme.tokens.spacing[3],
  },
  container: {
    flex: 1,
    padding: theme.tokens.spacing[4],
    paddingBottom: theme.tokens.spacing[8],
  },
  content: {
    gap: theme.tokens.spacing[6],
  },
  headerContainer: {
    alignItems: 'center',
    gap: theme.tokens.spacing[2],
  },
  infoContainer: {
    backgroundColor: theme.colors.surfaceVariant,
    borderRadius: theme.tokens.containerBorderRadius,
    padding: theme.tokens.spacing[4],
  },
  infoText: {
    color: theme.colors.onSurfaceVariant,
    textAlign: 'center',
  },
  label: {
    marginBottom: theme.tokens.spacing[2],
  },
  subtitle: {
    color: theme.colors.onSurfaceVariant,
    textAlign: 'center',
  },
}))

export default Welcome
